import Collection from "../../data-structures/collection";
import Team from "./team";
import {BUS_TEAMS_CHANGED} from "./@const";

export default class Teams extends Collection<Team> {

    constructor(teams: Team[] = []) {
        super(teams)

        this.onChangeBusEvent = BUS_TEAMS_CHANGED
    }

    sort() {
        this.models = _.sortBy(this.models, 'name')
    }

    resetFromJson(data: JSONArray): void {
        const models: Team[] = []
        _.map(data, (data: JSONObject) => {
            models.push(new Team(data))
        })

        return this.reset(models)
    }

    addFromJson(data: JSONObject) {
        this.add(new Team(data))
    }

    findByUser(userId: ID): Team[] {
        return this.models.filter(team => team.userIds.includes(userId))
    }

    exportToOptions(): Option[] {
        return this.models.map(function(team: Team) {
            return {
                value: team.id,
                label: team.name
            }
        })
    }

} 